import { ButtonBase, styled as muiStyled } from '@mui/material'

export const GenericTimerTypeTabsContainer = muiStyled('div')(
  ({ theme }) => `
  display: grid;
    justify-content: center;
    align-items:center;
    border: 1px solid #fff;
    font-size: 14px;
    width: 100%;
    max-width: 300px;
    grid-template-columns: repeat(3, 1fr);
    margin-top: 40px;
    border-radius: 3px;
`,
)

export const GenericTimerTypeTabButton = muiStyled(ButtonBase)(
  ({ theme, selected }) => `
    color: ${selected ? '#000' : '#fff'};
    background: ${selected ? '#fff' : 'transparent'};
    transition: all 400ms ${theme.transitions.easing.quickInOut};
    padding: 5px 0;
    &:hover{
        background: ${selected ? '#fff' : '#ffffff2b'};
        color: ${selected ? '#000' : '#fff'};
    }
`,
)
